module.exports = __webpack_public_path__ + "img/675-790a47.png";